"use client";
import React, { Suspense, lazy } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import LoadingSpinner from "@/components/LoadingSpinner";

// Lazy loading de componentes
const AboutHeader = lazy(() => import("@/components/nosotros/AboutHeader").then(m => ({ default: m.AboutHeader })));
const AboutHistory = lazy(() => import("@/components/nosotros/AboutHistory").then(m => ({ default: m.AboutHistory })));
const AboutTeam = lazy(() => import("@/components/nosotros/AboutTeam").then(m => ({ default: m.AboutTeam })));
// const Layout216 = lazy(() => import("@/components/nosotros/Layout216").then(m => ({ default: m.Layout216 })));
const Logo2 = lazy(() => import("@/components/nosotros/Logo2").then(m => ({ default: m.Logo2 })));
const Testimonial4 = lazy(() => import("@/components/nosotros/Testimonial4").then(m => ({ default: m.Testimonial4 })));

export default function Page() {
  return (
    <div>
      <Navbar />
      
      <Suspense fallback={<LoadingSpinner text="Cargando información de la empresa..." className="py-20" />}>
        <AboutHeader />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner text="Cargando historia..." className="py-12" />}>
        <AboutHistory />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner text="Cargando equipo..." className="py-12" />}>
        <AboutTeam />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner text="Cargando marcas..." className="py-12" />}>
        <Logo2 />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner text="Cargando testimonios..." className="py-12" />}>
        <Testimonial4 />
      </Suspense>
      
      <Footer />
    </div>
  );
}
